"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftTrackerToJSON = exports.NftTrackerFromJSONTyped = exports.NftTrackerFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NftTrackerFromJSON(json) {
    return NftTrackerFromJSONTyped(json, false);
}
exports.NftTrackerFromJSON = NftTrackerFromJSON;
function NftTrackerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'grouping': json['grouping'],
        'contractAddress': json['contractAddress'],
        'evmChain': (0, _1.EVMChainFromJSON)(json['evmChain']),
        'name': json['name'],
        'openSea': json['openSea'],
        'isIneligibleForLeaderboards': !(0, runtime_1.exists)(json, 'isIneligibleForLeaderboards') ? undefined : json['isIneligibleForLeaderboards'],
        'maxLimitMint': !(0, runtime_1.exists)(json, 'maxLimitMint') ? undefined : json['maxLimitMint'],
        'useThirdwebEngine': !(0, runtime_1.exists)(json, 'useThirdwebEngine') ? undefined : json['useThirdwebEngine'],
        'relayerUrl': !(0, runtime_1.exists)(json, 'relayerUrl') ? undefined : json['relayerUrl'],
        'forwarderAddress': !(0, runtime_1.exists)(json, 'forwarderAddress') ? undefined : json['forwarderAddress'],
        'mintVirtually': !(0, runtime_1.exists)(json, 'mintVirtually') ? undefined : json['mintVirtually'],
        'mintImage': !(0, runtime_1.exists)(json, 'mintImage') ? undefined : json['mintImage'],
    };
}
exports.NftTrackerFromJSONTyped = NftTrackerFromJSONTyped;
function NftTrackerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'grouping': value.grouping,
        'contractAddress': value.contractAddress,
        'evmChain': (0, _1.EVMChainToJSON)(value.evmChain),
        'name': value.name,
        'openSea': value.openSea,
        'isIneligibleForLeaderboards': value.isIneligibleForLeaderboards,
        'maxLimitMint': value.maxLimitMint,
        'useThirdwebEngine': value.useThirdwebEngine,
        'relayerUrl': value.relayerUrl,
        'forwarderAddress': value.forwarderAddress,
        'mintVirtually': value.mintVirtually,
        'mintImage': value.mintImage,
    };
}
exports.NftTrackerToJSON = NftTrackerToJSON;
